<template>
  <div>
    <div
      class="dashboard__gallery-item-wrap"
      :class="{ 'dashboard__gallery-item-wrap--wide': !gallery }"
      v-if="!empty"
    >
      <div class="dashboard__timer-detail-image-wrap">
        <div
          v-if="!timerPreview"
          class="dashboard__gallery-item--loading-preview"
        >
          <spring-spinner
            :animation-duration="1500"
            :size="48"
            :color="'#b6bbff'"
            transition="fade"
            mode="out-in"
            :duration="1000"
            enter-active-class="enter-active"
            slot="waiting"
            style="margin-top: 160px; margin-bottom: 160px;"
          />
        </div>
        <router-link
          :to="{
            name: 'timer details',
            query: { timerId: timer.widget.id },
          }"
          class="button button--secondary button--small button--narrow"
        >
          Timer Details
        </router-link>

        <img
          v-show="timerPreview"
          :src="timerPreview"
          alt="timer"
          ref="imgPreview"
        />
      </div>
      <Divider dark class="layout--margin-bottom-sm" />
      <div class="dashboard__timer-detail-content-wrap">
        <h2
          class="layout--margin-bottom-xs layout--one-line text-size-sm"
          v-if="gallery"
        >
          {{ timer.widget.name }}
        </h2>
        <div class="dashboard__timer-detail-wrap">
          <!-- <div v-if="gallery" class="layout--margin-bottom-xs layout--margin-right-md">
            <IconEye
              class="icon icon--medium"
              style="width: 18px; height: 12px; margin-right: 5px;"
            />{{ timer.impressionCount.toLocaleString("en-US") }} Impressions <i>
              (last 30 days)</i
            >
          </div> -->
          <div
            v-if="!gallery"
            class="layout--margin-bottom-xs layout--margin-right-md"
          >
            <IconEye
              class="icon icon--medium"
              style="width: 18px; height: 12px; margin-right: 5px;"
            />{{ timer.impressionCountAllTime.toLocaleString("en-US") }} Total
            Impressions
          </div>
          <div
            :class="{
              'layout--margin-bottom-md': gallery,
              'dashboard__timer-status-wrap': true,
            }"
          >
            <IconDate
              class="icon icon--medium"
              style="width: 18px; height: 22px; margin-right: 5px;"
            />Created on
            {{ createdDate.getDate() }}
            {{
              createdDate
                .toLocaleString("en-US", {
                  month: "short",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })
                .replace(",", "")
            }}
          </div>
          <div
            :class="{
              'layout--margin-bottom-md': gallery,
              'dashboard__timer-status-wrap': true,
            }"
          >
            <component
              :is="timer.ended ? 'IconEnded' : 'IconCounting'"
              class="icon"
              style="width: 14px; height: 18px; margin-left: 2px; margin-right: 8px; margin-top: 3px;"
            />
            {{ timer.endDateTimeFormatted }}
            <br />
            {{ timer.endTimeZoneInfoFormatted }}
            <span
              v-if="timer.ended"
              class="button button--narrow dashboard__status dashboard__status--small layout--margin-left-sm layout--hide-tablet-landscape-down"
              ><strong>ENDED</strong></span
            >
          </div>
        </div>
        <div>
          <Controls :timer="timer" :wide="!gallery" />
        </div>
      </div>
    </div>
    <div
      class="layout--text-center"
      :class="{
        'dashboard__gallery-item-wrap dashboard__gallery-item-wrap--no-timers': gallery,
      }"
      v-if="empty"
    >
      <IconRabbit
        class="icon icon--gray icon--extra-large layout--margin-bottom-md"
      />
      <h2 class="text-size-sm layout--margin-bottom-xs layout--ellipses">
        No timers here yet!
      </h2>
      <p class="text-size-sm weight--ethereal layout--margin-bottom-md">
        Ready to start a countdown?
      </p>
      <router-link
        :to="{ name: 'create a timer' }"
        class="button button--secondary button--big"
        ><font-awesome-icon
          icon="plus-circle"
          class="icon icon--medium-large icon--green layout--margin-right-xxs"
        />
        Create a timer
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapWaitingActions } from "vue-wait";

import Divider from "./Divider";
import Controls from "./TimerControls";

import IconEye from "../assets/icons/iconImpressionsEye.svg";
import IconDate from "../assets/icons/iconCreatedDate.svg";
import IconCounting from "../assets/icons/iconTimerCounting.svg";
import IconEnded from "../assets/icons/iconTimerEnded.svg";
import IconRabbit from "../assets/icons/iconWhiteRabbit.svg";

export default {
  name: "timer-preview",
  props: { timer: Object, empty: Boolean, gallery: Boolean },
  components: {
    Controls,
    Divider,
    IconEye,
    IconDate,
    IconCounting,
    IconEnded,
    IconRabbit,
  },
  mounted: function() {
    if (this.timerPreview === "" && !this.empty) {
      this.getTimerPreview({
        ...this.timer.widget,
        scaleFactor: 1,
      })
        .then(result => {
          const fileURL = window.URL.createObjectURL(new Blob([result.data]));
          this.timerPreview = fileURL;
        })
        .catch(error => console.log(error));
    }
  },
  data() {
    return {
      timerPreview: "",
    };
  },
  computed: {
    createdDate() {
      return new Date(this.timer.widget.createdAt);
    },
  },
  methods: {
    ...mapWaitingActions("timers", {
      getTimerPreview: "loading timer preview",
    }),
  },
};
</script>

<style></style>
